import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable, of, tap} from "rxjs";
import camelcaseKeys from "camelcase-keys";
import {BuildKit, CadModelRevisionQuantity, Traveler,} from "../../shared/models/build-kit.model";
import {Report} from "../models/report.model";
import {saveAs} from "file-saver";
import {v4 as uuidv4} from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  generate(buildKitId: number, reportType:string, fileName: string, settings: any){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + 'report/generate/', {
      buildKitId,
      type: reportType,
      fileName: fileName,
      settings: settings
    });
  }

  download(id: string, fileName: string){
    return this.http.get(this.brennerSoftwareApiEndpoint + `report/download/${id}`, {responseType: "blob"})
      .pipe(tap(x => saveAs(x, fileName)));
  }

  get(): Observable<Report[]>{
    return this.http.get<any[]>(this.brennerSoftwareApiEndpoint + `report/getList/`)
      .pipe(map(reports => {
        return reports.map(report => {
          return {
            ...report,
            settings: JSON.parse(report?.settings)
          }
        })
      }));
      // .pipe(map(buildKits => this.parseReportResults(buildKits)));
  }

  getReportWithValidationMessages(reportId: string): Observable<Report>{
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `report/getIncludeMessages/${reportId}`)
      .pipe(map(report => {
        return {
          ...report,
          settings: JSON.parse(report?.settings)
        }
      }));
    // .pipe(map(buildKits => this.parseReportResults(buildKits)));
  }


  remove(reportId: string): Observable<any>{
    return this.http.delete<any>(this.brennerSoftwareApiEndpoint + `report/delete/${reportId}`);
  }
}
